module.exports = __webpack_public_path__ + "static/img/ewm_copy.0a5c20a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ewm_copy.png
// module id = yTim
// module chunks = 1